import React from "react";
import "./AirFrieghtDomesticList.css";
import SearchIcon from "@mui/icons-material/Search";

const AirFrieghtDomesticList = ({
  userDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  openAddProfile,
  setOpenAddProfile,
}) => {
  function HandleChange(param) {
    GetId(param);
  }

  function getStatusColor(status) {
    switch (status) {
      case "ACTIVE":
        return "#28A745";
      case "INACTIVE":
        return "#DC3545";
      default:
        return "blue";
    }
  }

  return (
    <div
      style={{
        overflowX: "auto",
        padding: "1rem", 
        width:"auto"
      }}
    >
      <table
        className="FrieghtList"
        style={{ width: "100%", border: "1px solid #ddd" }}
      >
        <tr
          style={{
            backgroundColor: "#f2f2f2",
            padding: "5px",
            border: "1px solid #6c757d",
          }}
        >
          <th style={{ width: "5%", fontSize: "14px" }}>Sr.No</th>
          <th style={{ width: "5%", fontSize: "14px" }}>Origin Code</th>
          <th style={{ width: "7%", fontSize: "14px" }}>Destination Code</th>
          <th style={{ width: "7%", fontSize: "14px" }}>Lane</th>
          <th style={{ width: "7%", fontSize: "14px" }}>
            <span style={{ fontSize: "14px" }}> Prime/GCR/SCR</span>
          </th>
          <th style={{ width: "5%", fontSize: "14px" }}>MIN</th>
          <th style={{ width: "5%", fontSize: "14px" }}>Normal</th>
          <th style={{ width: "5%", fontSize: "14px" }}>Per Kg Rate</th>
          <th style={{ width: "9%", fontSize: "14px" }}>AVI Handling</th>
          <th style={{ width: "7%", fontSize: "14px" }}>DDC</th>
          <th style={{ width: "8%", fontSize: "14px" }}>FLC 2/200</th>
          <th style={{ width: "8%", fontSize: "14px" }}>X-Ray</th>

          <th style={{ width: "8%", fontSize: "14px" }}>X-Ray/Min</th>
          <th style={{ width: "9%", fontSize: "14px" }}>HCC/Min</th>
          <th style={{ width: "5%", fontSize: "14px" }}>Out XCC</th>
          <th style={{ width: "5%", fontSize: "14px" }}>OUT TSP</th>
          <th style={{ width: "5%", fontSize: "14px" }}>IN TSP</th>
          <th style={{ width: "5%", fontSize: "14px" }}>Search</th>
        </tr>
        {userDetailResponse !== null ? (
          userDetailResponse.map((user, index) => (
            <tr key={user.Tseed}>
              <td>{++index}</td>
              <td>{user.Origin_Code}</td>
              <td>{user.Destination_Code}</td>
              <td>{user.Lane}</td>
              <td>{user.Prime_GCR_Lean_SCR}</td>
              <td>{user.MIN}</td>
              <td>{user.Normal}</td>
              <td>{user.PER_KG_RATE}</td>
              <td>{user.AVI_HANDLING}</td>
              <td>{user.DDC}</td>
              <td>{user.FLC}</td>
              <td>{user.XRAY}</td>
              <td>{user.XRAY}</td>


              <td>{user.HCC}</td>
              <td>{user.OUT_XCC}</td>

              <td>{user.OUT_TSP}</td>
              <td>{user.IN_TSP}</td>
              <td>
                  <button
                    style={{ height: "30px", width: "38px" }}
                    onClick={() => {
                      setOpenProfile(!openProfile);
                      HandleChange(user.Tseed);
                      setOpenAddProfile(false);
                    }}
                  >
                 <SearchIcon className="icon"/>
                  </button>
                </td>
            </tr>
          ))
        ) : (
          <p>empty</p>
        )}
      </table>
    </div>
  );
};

export default AirFrieghtDomesticList;
